import React, { useState } from 'react';
import LoadingButton from '@mui/lab/LoadingButton';

const ButtonLinkHref = ({
                            to,
                            className = '',
                            children,
                            openInNewTab = false,
                        }) => {
    const [loading, setLoading] = useState(false);

    const handleClick = (e) => {
        if (loading) {
            e.preventDefault();
            return;
        }

        setLoading(true);
        // simulate navigation delay (optional)
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    };

    return (
        <a
            href={to}
            target={openInNewTab ? '_blank' : '_self'}
            rel={openInNewTab ? 'noopener noreferrer' : undefined}
            style={{ textDecoration: 'none' }}
            onClick={handleClick}
        >
            <LoadingButton
                loading={loading}
                variant="contained"
                sx={{
                    paddingX: 3,
                    paddingY: 1.5,
                    backgroundColor: '#000000',
                    '&:hover': {
                        backgroundColor: '#1a1a1a',
                    },
                    color: '#ffffff',
                    textTransform: 'none',
                    borderRadius: '16px',
                    boxShadow: 'none',
                }}
                className={className}
            >
                {children}
            </LoadingButton>
        </a>
    );
};

export default ButtonLinkHref;
